// Module
var code = `<template class="notifications-list">
  <require from="./notifications-list.scss"></require>
  <require from="../process-document-notification-to-document-id-converter"></require>
  <require from="../process-voucher-notification-to-voucher-id-converter"></require>
  <require from="./notification-status-converter"></require>

  <div if.bind="!notifications.length">No new notifications for the selected company</div>
  <div class="notifications-list__show-more" mdc-caption>
    <a route-href="notifications">Show all</a> <a if.bind="notifications.length" href="#" click.trigger="dismissAll()">Dismiss all</a>
  </div>
  <template repeat.for="n of notifications">
    <mdc-list-divider></mdc-list-divider>
    <div class="notification">
      <div class="notification__title" mdc-subtitle1>
        <let document-id.bind="n | processDocumentNotificationToDocumentId"></let>
        <let new-voucher-id.bind="n | processVoucherNotificationToVoucherId"></let>
        <let status-icon-info.bind="n | notificationStatus"></let>
        <mdc-icon class="align-self \${statusIconInfo.class}">\${statusIconInfo.icon}</mdc-icon>&nbsp;
        <span>\${n.text} <mdc-icon click.trigger="copyToClipboard(n)">content_copy</mdc-icon>
          <a if.bind="n.type === NotificationType.ProcessDocument && documentId" class="notification__upv-list-link" route-href="route: unprocessed-voucher-list; params.bind: {voucherDocumentId: documentId}">
            <mdc-icon>list</mdc-icon>
          </a>
          <a if.bind="newVoucherId && documentId" class="notification__upv-list-link" route-href="route: upv; params.bind: {documentId: documentId, voucherId: newVoucherId}">
            <mdc-icon>fast_forward</mdc-icon>
          </a>
        </span>
        <mdc-icon if.bind="n.type === NotificationType.ProcessVouchers" class="notification__expand" click.trigger="n.expanded = !n.expanded">\${n.expanded ? 'expand_less' : 'expand_more'}
        </mdc-icon>
        <mdc-icon class="notification__close" click.trigger="deleteNotification(n)">close</mdc-icon>
      </div>
      <div if.bind="n.type !== NotificationType.ProcessVouchers || n.expanded">
        <div repeat.for="s of n.steps" mdc-body2 class="notification__step \${s.status === NotificationStepStatus.Pending ? 'mdc-theme--text-disabled-on-background' : ''}">
          <div class="notification__step-title">            \${s | notificationStep:n}
            <mdc-icon if.bind="s.status === NotificationStepStatus.Pending">schedule</mdc-icon>
            <mdc-icon if.bind="s.status === NotificationStepStatus.InProgress">schedule</mdc-icon>
            <mdc-icon if.bind="s.status === NotificationStepStatus.Success" class="mdc-theme--primary">check</mdc-icon>
            <mdc-icon if.bind="s.status === NotificationStepStatus.Warning" class="warning">warning</mdc-icon>
            <mdc-icon if.bind="s.status === NotificationStepStatus.Error" class="mdc-theme--error">error</mdc-icon>
            <let has-drilldown-text.bind="s.text && s.status !== NotificationStepStatus.Error && s.status !== NotificationStepStatus.Warning"></let>
            <a if.bind="hasDrilldownText" class="notification__step-details-link" click.trigger="s.textOpen = !s.textOpen">
              <mdc-icon>\${s.textOpen ? 'expand_less' : 'expand_more'}</mdc-icon>
            </a>
          </div>
          <div if.bind="s.status === NotificationStepStatus.Error" class="mdc-theme--error">\${s.text}</div>
          <div if.bind="s.status === NotificationStepStatus.Warning" class="warning">\${s.text}</div>
          <div if.bind="hasDrilldownText && s.textOpen">\${s.text}</div>
          <div if.bind="s.debugMessage" class="mdc-theme--error">
            <br>
            <a class="notification__step-details-link" click.trigger="s.detailsOpen = !s.detailsOpen">Details:</a>
            <div class="notification__step-details\${s.detailsOpen ? '' : '-closed'}">\${s.debugMessage}</div>
          </div>
          <div if.bind="s.status === NotificationStepStatus.Error || s.status === NotificationStepStatus.Warning" class="mdc-theme--on-surface">
            <br>
            <strong>Need help? Click <a class="dynamik-link" href="https://hjelp.dynamik.no/portal/nb/kb/articles/tilbakemelding-ved-behandling-av-sluttsedler" target="_blank">here <span class="material-icons">open_in_new</span></a> for a solution.</strong>
            <br><br>
          </div>
          <mdc-linear-progress if.bind="s.status === NotificationStepStatus.InProgress" open progress.bind="s.expectedProgress ? s.progresses.length / s.expectedProgress : undefined" dir="ltr">
          </mdc-linear-progress>
        </div>
      </div>
      <div class="notification__date mdc-theme--text-disabled-on-dark" mdc-caption>
        <span>
          \${n.date | dateTimeConverter}
        </span>
      </div>
    </div>
    <mdc-list-divider if.bind="\$last"></mdc-list-divider>
  </template>
</template>
`;
// Exports
export default code;